import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { failureAction, pendingAction, successAction } from './actionHandler';

interface ConnectionState {
  connected: boolean;
  connectionId?: string;
}

const initialState: ConnectionState = {
  connected: false,
};

const connectionSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {
    connect: pendingAction(),
    connectSuccess: successAction<
      ConnectionState,
      { connectionId: string | null; connected: boolean }
    >((state, { payload: { connectionId, connected } }) => {
      state.connected = connected;
      if (connectionId) {
        state.connectionId = connectionId;
      }
    }),
    connectFailure: failureAction<ConnectionState>(state => {
      state.connected = false;
    }),
    connectAndSignIn: pendingAction<
      ConnectionState,
      { isReconnection: boolean }
    >(),
    connectAndSignInSuccess: successAction<
      ConnectionState,
      { isReconnection: boolean }
    >(),
    connectAndSignInFailure: failureAction(),
    setConnectionStatus(
      state,
      { payload: { connected } }: PayloadAction<{ connected: boolean }>
    ) {
      state.connected = connected;
    },
  },
});

export const connectionReducer = connectionSlice.reducer;

export default connectionSlice.actions;
